import React, { useEffect } from 'react';
import ServicesHero from '../components/sections/ServicesHero';
import ServicesAlt4 from '../components/sections/ServicesAlt4';
import Process4 from '../components/sections/Process4';
import ServicesFAQ from '../components/sections/ServicesFAQ';

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="relative pt-20">
      <ServicesHero />
      <ServicesAlt4 />
      <Process4 />
      <ServicesFAQ />
    </main>
  );
};

export default Services;
